import * as React from 'react';
import { IconClose16 } from '@cian/ui-kit';

import { HeaderButton, IHeaderButtonProps } from '../HeaderButton';

type TDeleteButtonProps = IHeaderButtonProps;

export const DeleteButton = (props: TDeleteButtonProps) => (
  <HeaderButton {...props} dataTestId="DeleteButton">
    <IconClose16 color="gray_icons_100" />
  </HeaderButton>
);
